import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "coupe"
const CoupeIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 11s1.5-3 6-3c2.316 0 4.103.795 5.836 1.566C16.471 10.293 18.06 11 20 11h-1.5c4.847 0 4.646 2.245 4.53 3.537-.016.174-.03.331-.03.463v1.5h-1.402a3.001 3.001 0 0 1-5.196 0H7.598a3 3 0 0 1-5.196 0H1V11h2Zm2 2.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM8.833 11H15.5c-.847 0-1.624-.278-2.509-.595-1.154-.413-2.491-.891-4.408-.905l.25 1.5Zm-1 0H5s.046-1.223 2.59-1.46L7.833 11Z"
      />
    </svg>
  )
}
export default CoupeIcon
